<template>
	<div class="sync-right-body" id="cloudSync" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.05)">
		<div class="task-top">
			<div class="task-top-position">
				<div class="transfer-name">{{$t('language.leftBanner.cloudSync')}}</div>
				<div class="transfer-description">{{$t('language.cloudSync.syncDescription')}}</div>
			</div>
		</div>
		<!-- <input ref="realtimeTest"  style="width: 200px;/*no*/ " /> -->
		<div class="task-middle">
            <div class="sync-choose" v-show="!$store.state.isLiteMode">
                <div class="realTime-choose-button"  :style={width:getWidth()}  @click="onChangeRealTimeOption($t('language.cloudSync.normalSync'))" :class="!realTimeMode?'realTime-select':'realTime-no-select'">{{$t('language.cloudSync.normalSync')}}</div>
                <div class="realTime-choose-button"  :style={width:getWidth()} @click="onChangeRealTimeOption($t('language.cloudSync.realTimeSync'))" :class="realTimeMode?'realTime-select':'realTime-no-select'">{{$t('language.cloudSync.realTimeSync')}}</div>
			</div>
			<div class="task-box-position">
				<div class="task-box" :class="boxFrom" @click="syncSourceDialogShow()">
					<liteSelectView :data="liteSelectFromData" />
					<div class="task-operating" v-if="hasSelect">
						<div :class="$i18n.locale=='france'?'task-operating-none':'task-operating-name'">
                              <span v-if="$i18n.locale=='japanese'">{{$t('language.cloudSync.from')}}</span>
                              <span v-else>{{$t('language.cloudTransfer.from')}}</span>
                        </div>
						<div class="task-operating-des">{{$t('language.cloudSync.syncOperateFrom')}}</div>
					</div>
					<div class="task-main" v-if="!hasSelect">
						<div class="task-type task-icon" v-bind:class="singleDrives.driveType+'_big'"></div>
						<div class="task-catalog" :title="singleDrives.cloudCatalog">{{singleDrives.cloudCatalog}}</div>
					</div>
				</div>
				<div class="task-box-middle" v-if="!twoWayShow">
					<div class="arrow-position"></div>
                    <div class="realTime-font" @click='switchModelType()' >{{$t('language.cloudSync.swicthTwoWay')}}</div>
				</div>
				<div class="task-box-middle" v-if="twoWayShow">
					<div class="arrow-position arrow-top-position"></div>
					<div class="arrow-position arrow-position-reverse"></div>
                    <div class="realTime-font" @click='switchModelType()' v-show="!$store.state.isLiteMode">{{$t('language.cloudSync.switchOneWay')}}</div>
				</div>
				<div class="task-box" :class="boxTo" @click="syncAimDialogShow()">
					<liteSelectView :data="liteSelectToData" />
					<el-scrollbar style="height:100%;">
						<div class="task-operating" v-if="(hasSelectItems==false&&hasSelectItemsMore==false)||mulitDrives.length==0">
							<div class="task-operating-name">
                              <span v-if="$i18n.locale=='japanese'">{{$t('language.cloudSync.to')}}</span>
                              <span v-else>{{$t('language.cloudTransfer.to')}}</span>
                            </div>
							<div class="task-operating-des">{{$t('language.cloudSync.syncOperateTo')}}</div>
						</div>
						<div class="task-main" v-if="hasSelectItems||mulitDrives.length==1">
							<div class="task-type task-icon" :class="mulitDrives[0].driveType+'_big'"></div>
							<div class="task-catalog" :title="mulitDrives[0].formUrl">{{mulitDrives[0].formUrl}}</div>
						</div>
						<div class="task-source-more" v-if="hasSelectItemsMore&&mulitDrives.length>1">
							<div class="source-item" @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" :key="index" v-for="(item,index) in mulitDrives">
								<div class="item-side">
									<div class="item-formicon" :class="[item.dir?'small-file':'icon',item.dir?'folder-small':item.appName+'-small']"></div>
									<div class="item-url" :title="item.formUrl">{{item.formUrl}}</div>
									<div v-if="hoverCurrent==index" class="icon-util round-cancel round-cancel-position" @click.stop="removeItem(index,item.id)"></div>
								</div>
							</div>
						</div>
					</el-scrollbar>
				</div>
			</div>
			<div class="definite-operating">
				<div style="position:relative;">
					<div class="operating-options" @click="openSyncOptionsDialog()">
						<div class="icon-util setting" style="float:left;"></div>
						<div class="operating-position">{{$t('language.common.options')}}</div>
					</div>
					<div  v-if="scheduleShow && !$store.state.isLiteMode" class="operating-schedule" @click="openSchduleDialog()">
						<div class="icon-util" :class="checkedSchedule?'check':'nocheck'" @click.stop="checkedOpen()" style="float:left;"></div>
						<div class="operating-position">{{$t('language.common.schedule')}}</div>
					</div>
					<edit-input ref="editInput" :inputValue="inputValue" :submitTaskName="submiSynctName"></edit-input>
					<button class="transfer-button" v-if="!checkedSchedule" @click="syncNow()">
						<div class="icon sync-icon-position cloudsync"></div>
						<div style="float:left;line-height:40px;/*no*/">{{$t('language.cloudSync.syncNow')}}</div>
					</button>
					<div class="schedule-button" v-if="checkedSchedule" v-on:click="syncAddTask($event)">
						<div class="text-button-position">
							<div class="icon transfer-task-position  cloudsync"></div>
							<div style="float:left;color:#fff">{{$t('language.cloudTransfer.addTaskOnly')}}</div>
						</div>
						<div class="more-button-position" v-on:click.stop="addTaskOpen($event),$event.cancelBubble = true">
							<div v-on:click.stop="addTaskOpen($event)" class="icon-util  transfer-up-position" :class="addTaskShow?'transfer-up':'transfer-down'"></div>
						</div>
					</div>
					<div class="addTask" v-if="addTaskShow" v-on:click.stop="addTaskSyncNow()">
						<div class="task-type-icon-min sync-blue-min sync-blue-position"></div>
						<div style="float:left;">{{$t('language.cloudTransfer.addSyncTaskNow')}}</div>
					</div>
					<transition name="flowSync">
						<div class="flow-sync-icon" v-if="flowShow" id='syncFlow'>
							<div class="icon transfer-task-position cloudsync flow-sync-position"></div>
						</div>
					</transition>
				</div>
			</div>
		</div>
		<div class="task-buttom"></div>
		<syncSourceDialog ref="syncSourceDialog"></syncSourceDialog>
		<syncAimsDialog ref="syncAimsDialog"></syncAimsDialog>
		<syncOptionsDialog ref="syncOptionsDialog"></syncOptionsDialog>
		<transferScheduleDialog ref="transferScheduleDialog"></transferScheduleDialog>
		<upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
		<remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
        <realTimeNoticeDialog ref="realTimeNoticeDialog"></realTimeNoticeDialog>
        <idlingDialog ref="idlingDialog"></idlingDialog>
		<liteSelect ref="syncFromTree" :showCheckbox="false" :showFileNode="false" :showNewFolder="false" @selectDone="selectDoneFrom" />
		<liteSelect ref="syncToTree" :showCheckbox="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
		<liteOptions ref="syncOptions" :data="liteOptionsData" @ok="okOptions" />
	</div>
</template>

<script>
	import { Message } from "element-ui";
	import requestUtils from '@/js/request_util.js';
	//显示账号升级弹窗
	import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
	import cloudSelect from "@/components/common/select/cloud_select";
	import syncSourceDialog from "@/components/popup/cloud_transfer_popups/sync_single_popup";
	import syncAimsDialog from "@/components/popup/cloud_transfer_popups/sync_multi_popup";
	import syncOptionsDialog from "@/components/popup/cloud_transfer_popups/sync_options_popup";
	import transferScheduleDialog from "@/components/popup/cloud_transfer_popups/task_schedule_popup";
	import editInput from "@/components/common/input/edit_input";
	import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
	import commonUtils from "@/js/workspace/common_util.js";
	import taskListUtils from "@/js/workspace/task_list_util.js";
	import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
	import commonstate from '@/js/constant.js';
    import realTimeNoticeDialog from '@/components/popup/cloud_transfer_popups/realtime_notice_popup';
    import idlingDialog from '@/components/popup/cloud_transfer_popups/idling_popup';
	import liteOptions from "@/components/workspace/lite_options";
	import liteSelect from "@/components/workspace/lite_select";
	import liteSelectView from "@/components/workspace/lite_select_view";
	export default {
		name: "taskSync",
		components: {
			"cloud-select": cloudSelect,
			syncSourceDialog,
			syncAimsDialog,
			"edit-input": editInput,
			syncOptionsDialog,
			transferScheduleDialog,
			upgradeNewDialog,
			remindBindEmailDialog,
            realTimeNoticeDialog,
			liteOptions,
			liteSelect,
			liteSelectView,
            idlingDialog
		},
		data: function() {
			return {
				flowShow: false,
				singleDrives: {},
				mulitDrives: [],
				selectOption: [{
						name: this.$t("language.popup.twowaySync"),
						icon: false,
						id: 1
					},
					{
						name: this.$t("language.popup.advancedSync"),
						icon: true,
						id: 2
					}
				],
				selectOptionAll: [{
						name: this.$t("language.popup.onewaySync"),
						icon: false,
						id: 0
					}, {
						name: this.$t("language.popup.twowaySync"),
						icon: false,
						id: 1
					},
					{
						name: this.$t("language.popup.advancedSync"),
						icon: true,
						id: 2
					}
				],
				selectValue: this.$t("language.popup.onewaySync"),
				cloudType: "",
				cloudCatalog: "",
				hasSelect: true,
				hasSelectItemsMore: false,
				hasSelectItems: false,
				drives: [],
				inputValue: commonUtils.getTaskTxt(this),
				twoWayShow: false,
				checkedSchedule: false,
				hoverCurrent: -1,
				deleteOption: null,
				allLength: 0,
				folderType: 'small-file type-icon-position',
				fileType: 'icon type-drive-position',
				addTaskShow: false,
				pOptions: {
                    isChar: 1
				},
				pSchedules: {
					type: 'Now'
				},
				boxFrom: '',
				boxTo: '',
				addTaskFlag: true,
				loading: false,
				optionOpen: false, //标志是否是打开了open选项设置同步方式
                realTimeShow:true,//标识是否显示即时同步的页面
                scheduleShow:true,
                realTimeMode:false,//标识是否是即时同步模式
				liteSelectFromData: null,
				liteSelectToData: null,
				liteOptionsData: {
					listThread: commonUtils.getUser().vip ? 3 : 1,
                	runThread: commonUtils.getUser().vip ? 10 : 2,
					email: '',
					cron: '',
					excludeNames: [],
					allowedExtensions: [],
				},
				createTasking: false,
			};
		},
		watch: {
			'$store.state.taskListArr': function(newValue, oldValue) {
				let allTasklistData = this.$store.state.taskListArr;
				commonUtils.changeTaskNameLength(allTasklistData, this);
			},
		},
		created() {
			this.$store.state.arr = [];
			commonUtils.initPageName(this, 'cloudSync');
		},
		mounted() {
			//禁用拖拽功能
			commonUtils.dragDisAble('cloudSync', this);
            this.realTimeMode=false;
			if (this.$store.state.isLiteMode) {
				this.switchModelType();
			}
		},
		methods: {
			okOptions(data) {
				this.liteOptionsData = data;
			},
			selectDoneFrom(data) {
				this.liteSelectFromData = data;
			},
			selectDoneTo(data) {
				this.liteSelectToData = data;
			},
            switchModelType(){
                this.twoWayShow = !this.twoWayShow;
                if(this.twoWayShow){
                  if(this.mulitDrives.length>1){
                      this.mulitDrives=[];
                  }
                  this.$refs.syncOptionsDialog.options.way = 20;
                  this.pOptions.way = 20;
                  this.$refs.syncOptionsDialog.$refs.tab1.onChangeOptionOne(this.$t('language.popup.twowaySync'));
                  this.$refs.syncOptionsDialog.$refs.tab1.$refs.selectOne.currentValue=this.$t('language.popup.twowaySync');
                  this.$refs.syncOptionsDialog.$refs.tab1.selectTwoShow=false;
             }else{
                  this.$refs.syncOptionsDialog.way = 10;
                  this.pOptions.way = 10;
                  this.$refs.syncOptionsDialog.$refs.tab1.onChangeOptionOne(this.$t('language.popup.onewaySync'));
                  this.$refs.syncOptionsDialog.$refs.tab1.$refs.selectOne.currentValue=this.$t('language.popup.onewaySync');
                  this.$refs.syncOptionsDialog.$refs.tab1.selectTwoShow=true;
               }
            },
			addTaskOpen(event) {
				event.cancelBubble = true;
				this.addTaskShow = !this.addTaskShow;
			},
			onDrag: function(e) {
				e.stopPropagation();
				e.preventDefault();
			},
			showOtherOptions(index) {
				if (this.deleteOption && this.deleteOption.length > 0) {
					this.selectOption.splice(this.deleteOption[0].id, 0, {
						id: this.deleteOption[0].id,
						icon: this.deleteOption[0].icon,
						name: this.deleteOption[0].name
					});
					if (this.deleteOption[0].id <= index) {
						this.deleteOption = this.selectOption.splice(index + 1, 1);
					} else {
						this.deleteOption = this.selectOption.splice(index, 1);
					}
					if (this.deleteOption[0].id == 1) {
						this.$refs.syncOptionsDialog.oldOptions.way = 20;
					}
					if (this.deleteOption[0].id == 0) {
						this.$refs.syncOptionsDialog.oldOptions.way = 10;
					}
				} else {
					this.selectOption.splice(0, 0, {
						id: 0,
						icon: false,
						name: this.$t("language.popup.onewaySync")
					});
					this.deleteOption = this.selectOption.splice(index + 1, 1);
				}
				this.$forceUpdate();
			},
            showRealTimeOtherOptions(index){
             if (this.deleteOption && this.deleteOption.length > 0) {
               this.realTimeSelectOption.splice(this.deleteOption[0].id, 0, {
						id: this.deleteOption[0].id,
						icon: this.deleteOption[0].icon,
						name: this.deleteOption[0].name
					});
             }else{
               this.realTimeSelectOption.splice(0, 0, {
						id: 0,
						icon: false,
						name: 'Normal Sync'
					});
			  this.deleteOption = this.realTimeSelectOption.splice(index + 1, 1);
             }
            },
			submiSynctName() {
                if(this.$refs.editInput.value.length>255){
                    this.$refs.editInput.value =  this.$refs.editInput.oldNameValue;
                     this.$toast({
                     text: this.$t('language.taskList.taskNameRule'),
                     type: 'fail',
                     idValue: "cloudSync"
                     });
                     return false;
                }
				commonUtils.submiTaskName(this);
			},
			//打开源弹窗
			syncSourceDialogShow() {
				if (this.$store.state.isLiteMode) {
					this.$refs.syncFromTree.show = true;
					return;
				}
				let that = this;
				this.$refs.syncSourceDialog.taskSingleShow = true;
				let checkedNodes = this.$refs.syncSourceDialog.checkedNodes;
				this.$store.commit('setClickItem', checkedNodes);
				this.$store.state.syncClickItem = -1;
				this.$store.state.syncArr = [];
				this.$store.state.arr = [];
                if(this.realTimeMode){//根据当页是否是即时同步模式来打开选项
                 this.$refs.syncSourceDialog.realTimeMode=true;
                }else{
                 this.$refs.syncSourceDialog.realTimeMode=false;
                }
				if (!checkedNodes || !checkedNodes.length) {
					let div = this.$refs.syncSourceDialog.$refs['elscrollbar'].wrap; //获取滚动条
					this.$forceUpdate();
					this.$nextTick(() => {
						this.$refs.syncSourceDialog.$refs['elscrollbar'].wrap.scrollTop = 0;
					});
				}
				if (this.singleDrives.name) {
					$.each(this.$refs.syncSourceDialog.model, function(index, item) {
						if (that.singleDrives.driveId == item.id && item.children && item.children.length) {
							item.open = true;
						}else{
                            item.open = false;
                        }
					});
				} else {
					$.each(this.$refs.syncSourceDialog.model, function(index, item) {
						item.open = false;
						if (item.children && item.children.length) {
							commonUtils.closeTree(item.children);
						}
					});
				}
				this.$nextTick(function() {
					that.$refs.syncSourceDialog.$refs.sourceTree.scrollTop = that.$refs.syncSourceDialog.scrollTopValue;
				});
				this.$store.commit("setTreeMoveSelect", true);
				this.$store.commit("setTransferFromOpen", false);
			},
			//打开同步目标弹窗
			syncAimDialogShow() {
				if (this.$store.state.isLiteMode) {
					this.$refs.syncToTree.show = true;
					return;
				}
				let that = this;
				this.$refs.syncAimsDialog.syncMultiShow = true;
                 if(this.realTimeMode){//根据当页是否是即时同步模式来打开选项
                 this.$refs.syncAimsDialog.realTimeMode =true;
                }else{
                 this.$refs.syncAimsDialog.realTimeMode =false;
                }
				let checkedNodes = this.$refs.syncAimsDialog.checkedNodes;
				if (!checkedNodes || !checkedNodes.length) { //如果没有选中则使滚动条滑到顶端
					let div = this.$refs.syncAimsDialog.$refs['elscrollbar'].wrap; //获取滚动条
					this.$forceUpdate();
					this.$nextTick(() => {
						this.$refs.syncAimsDialog.$refs['elscrollbar'].wrap.scrollTop = 0;
					});
				}
				this.$store.state.clickItem = -1;
				this.$store.state.arr = [];
                this.$store.state.syncClickItem = checkedNodes;
				this.$store.state.syncArr = checkedNodes;
                if(checkedNodes.length>1 && this.realTimeMode){
                   this.$store.state.syncClickItem=[];
                   this.$store.state.syncArr = [];
                }
                   if(this.twoWayShow && checkedNodes.length>1  ){
                   this.$store.state.syncClickItem=[];
                   this.$store.state.syncArr = [];
               }

				if (this.twoWayShow) {
					this.mulitDrives = [];
                    this.$store.state.syncArr=[];
					this.$store.commit('setSyncArrEmpty', []);
					this.$refs.syncAimsDialog.toWayShow = true;
					this.$store.commit('setSyncMultiSelect', false);
					let treeNodes = document.getElementsByClassName('tr-click');
					let length = treeNodes.length;
					for (let i = 0; i < treeNodes.length;) {
						treeNodes[0].classList.remove("tr-click");
					}
				} else {
					this.$refs.syncAimsDialog.toWayShow = false;
				}
				if (this.mulitDrives.length) {
					this.$store.state.syncArr = Object.assign([], this.mulitDrives);
					$.each(this.$store.state.syncArr, function(sIndex, sItem) {
						$.each(that.$refs.syncAimsDialog.model, function(index, item) {
							if (sItem.driveId == item.id && item.children && item.children.length) {
								item.open = true;
							}else{
                                item.open = false;
                            }
						});
					});
				} else {
					$.each(this.$refs.syncAimsDialog.model, function(index, item) {
						item.open = false;
						if (item.children && item.children.length) {
							commonUtils.closeTree(item.children);
						}
					});
				}
				this.$forceUpdate();
				this.$nextTick(function() {
					that.$refs.syncAimsDialog.$refs.aimTree.scrollTop = that.$refs.syncAimsDialog.scrollTopValue;
				});
				this.$store.commit("setTransferFromOpen", false);
			},
			//清除一个选中的任务
			removeItem(index, id) {
				this.mulitDrives.splice(index, 1);
			},
			//打开设置弹窗
			openSyncOptionsDialog() {
				if (this.$store.state.isLiteMode) {
					this.$refs.syncOptions.init();
					this.$refs.syncOptions.show = true;
					return;
				}
                let that = this;
                let tab1 = this.$refs.syncOptionsDialog.$refs.tab1;
				this.$refs.syncOptionsDialog.syncOptionShow = true;
				this.$refs.syncOptionsDialog.activeName = "first";
				this.$refs.syncOptionsDialog.indexCurrent = 0;
				this.$refs.syncOptionsDialog.downOpen = true;
				if (!this.checkedSchedule) {
					this.$refs.transferScheduleDialog.$refs.daily.checkArr = [0];
					this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = false;
				}
				if (!this.$refs.syncOptionsDialog.$refs.tab3.items.length) {
					this.$refs.syncOptionsDialog.$refs.tab3.radioCurrent = 0;
				}
                if(this.pOptions){
                   if(this.pOptions.way == 20){
                      this.$refs.syncOptionsDialog.options.way = 20;
                      tab1.$refs.selectOne.currentValue=this.$t('language.popup.twowaySync');
                }else{
                      this.$refs.syncOptionsDialog.way = 10;
                      if(!this.realTimeMode){
                      tab1.$refs.selectOne.currentValue=this.$t('language.popup.onewaySync');
                      }else{
                      tab1.$refs.selectOne.currentValue=this.$t('language.cloudSync.oneWaySimple');
                      }
                   }
                }
                //如果是即时同步打开弹窗
                if(this.realTimeMode){
                    tab1.realTimeMode=true;
                         if(this.pOptions.way != 20){
                    tab1.selectTwoShow=true;
                    tab1.selectOption=[{
                    name: this.$t('language.popup.twowaySync'),
                    id: 1
                   }];
                    }
                   //  tab1.selectValue=this.$t('language.cloudSync.oneWaySimple');
                    // tab1.selectOption=tab1.realTimeTypeSelectOption;//即时同步显示选项
                   //  tab1.$refs.selectOne.currentValue=this.$t('language.cloudSync.oneWaySimple');
                    tab1.$refs.selectrealTime.currentValue=this.$t('language.cloudSync.realTimeSync');
                    tab1.selectTwoShow=false;//不显示第三项
                    this.$refs.syncOptionsDialog.oldRealTimeMode=true;
                }else{
                     tab1.realTimeMode=false;
                    if(this.pOptions.way != 20){
                    tab1.selectTwoShow=true;
                    tab1.selectOption=[{
                    name: this.$t('language.popup.twowaySync'),
                    id: 1
                   }];
                    }
                    tab1.$refs.selectOne.setInputWidth()
                    tab1.$refs.selectrealTime.currentValue=this.$t('language.cloudSync.normalSync');
                    this.$refs.syncOptionsDialog.oldRealTimeMode=false;
                }
			},
			//更改下拉框选项
			onChangeOption(newValue) {
				this.selectOption = Object.assign([], this.selectOptionAll);
				switch (newValue.replace(/^\s+|\s+$/g, "")) {
					case this.$t("language.popup.onewaySync").replace(/^\s+|\s+$/g, ""):
						this.twoWayShow = false;
						if (!this.optionOpen) { //如果不是在option设置的值，直接通过右上角弹窗设置的
							this.pOptions = {
								way: 10,
								isChar: 1
							};
							this.$refs.syncOptionsDialog.options = {
								way: 10,
								isChar: 1
							};
							this.$refs.syncOptionsDialog.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.simpleSync');
						}
						this.$refs.syncOptionsDialog.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
						this.selectOption.splice(0, 1);
						this.optionOpen = false;
						break;
					case this.$t("language.popup.twowaySync").replace(/^\s+|\s+$/g, ""):
						this.twoWayShow = true;
						this.pOptions = {
							way: 20,
							isChar: 1
						};
						this.$refs.syncOptionsDialog.options = {
							way: 20,
							isChar: 1
						};
						this.$refs.syncOptionsDialog.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.twowaySync");
						if (this.mulitDrives.length > 1) {
							this.mulitDrives = [];
                            this.$store.state.syncArr=[];
						}
						this.optionOpen = false;
						this.selectOption.splice(1, 1);
						break;
					case this.$t("language.popup.advancedSync").replace(/^\s+|\s+$/g, ""):
						this.$refs.syncOptionsDialog.syncOptionShow = true;
						this.$refs.syncOptionsDialog.activeName = "first";
						this.$refs.syncOptionsDialog.tabView = "tab1";
						this.$refs.syncOptionsDialog.indexCurrent = 0;
						this.$refs.syncOptionsDialog.downOpen = false;
						this.optionOpen = false;
						this.selectOption.splice(2, 1);
						break;
				}
			},
            //更改即时同步下拉框选项改变参数
            onChangeRealTimeOption(newValue){
             switch (newValue.replace(/^\s+|\s+$/g, "")) {
             case this.$t('language.cloudSync.realTimeSync').replace(/^\s+|\s+$/g, ""):
                  this.scheduleShow=false;
                 // this.pOptions.way=10;
                  this.realTimeMode=true;
                  this.checkedSchedule=false;
                 // this.twoWayShow=false;
                  if(this.mulitDrives.length>1){
                  this.mulitDrives=[];
                  this.$store.state.syncArr=[];
                  }
                   if(this.pOptions.way==10){
                       this.twoWayShow=false;
                  }
                  break;
             case this.$t('language.cloudSync.normalSync').replace(/^\s+|\s+$/g, ""):
                  this.scheduleShow=true;
                  this.realTimeMode=false;
                  this.checkedSchedule=false;
                  this.$refs.syncAimsDialog.realTimeMode=false;
                  if(this.pOptions.way==10){
                       this.twoWayShow=false;
                  }
                  break;
             }

            },
			//打开时间设置弹窗
			openSchduleDialog() {
				this.$refs.transferScheduleDialog.taskSchduleShow = true;
                this.$refs.transferScheduleDialog.initPopup();
			},
			//当用户取消选择时间设置时默认传参数为‘Now’
			checkedOpen() {
				if (this.checkedSchedule) {
					this.checkedSchedule = false;
                    this.addTaskShow = false;
					this.pSchedules = {
						type: "Now"
					}
					this.clearAllTableData();
				} else {
					this.$refs.transferScheduleDialog.$refs.daily.checkArr = [0];
					this.openSchduleDialog();
				}
			},
			//清除界面数据
			clearAllTableData() {
				this.$refs.transferScheduleDialog.$refs.weekly.weekArr = [];
				this.$refs.transferScheduleDialog.$refs.monthly.monthArr = [];
				this.$refs.transferScheduleDialog.$refs.daily.checkArr = [];
				this.$refs.transferScheduleDialog.$refs.daily.dailyTimeArr = [];
				this.$refs.transferScheduleDialog.$refs.daily.dailyDisableFlage = true;
				this.$refs.transferScheduleDialog.$refs.daily.onceDisableFlage = true;
				this.$refs.transferScheduleDialog.oldSchedules = {};
				this.$refs.transferScheduleDialog.schedules = {};
			},
			// 发送Lite请求
			sendRequest(path, data, callback) {
				this.fullscreenLoading = true;
				requestUtils.doLiteRequest(path, data)
					.then(res => {
						this.fullscreenLoading = false;
						let code = res.code
						let msg = res.msg
						if (msg == undefined) {
							msg = res.message;
						}
						if (code == 200) {
							// 请求成功
							if (callback) {
								callback(res.data)
							}
						} else if (code == 400) {
							// 请求失败
							Message.warning(msg)
						} else {
							if (msg == "Unauthorized") {
								// 未登录
								location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
							} else {
								// 服务器异常
								Message.error(msg)
							}
						}
					}, err => {
						this.fullscreenLoading = false;
						// 请求异常
						Message.error(err)
					});
			},
			// 获取任务列表
			listTasks(callback) {
				this.sendRequest("/task/list", {}, (data) => {
					this.$store.state.tasks = data;
					if (callback) callback();
				})
			},
			//同步立刻执行
			syncNow() {
				if (this.$store.state.isLiteMode) {
					if (this.createTasking) return;
					if (!this.inputValue) {
						Message.error("Please input task name");
						return;
					}
					if (!this.liteSelectFromData) {
						this.boxFrom = "box-shake";
						setTimeout(() => {
							this.boxFrom = "box-shakeOrigin";
						}, 100);
						return;
					}
					if (!this.liteSelectToData) {
						this.boxTo = "box-shake";
						setTimeout(() => {
							this.boxTo = "box-shakeOrigin";
						}, 100);
						return;
					}
					const taskParam = {
						type: "sync",
						name: this.inputValue,
						fdid: this.liteSelectFromData.did,
						tdid: this.liteSelectToData.did,
						param: {
							from: this.liteSelectFromData.node,
							to: this.liteSelectToData.node,
							options: this.liteOptionsData,
						}
					}
					// 开始创建任务
					let that = this;
					this.createTasking = true;
					this.sendRequest("/task/create", taskParam, () => {
						taskListUtils.exeSuccessEnd('syncFlow', 'taskList', [], that);
						this.liteSelectFromData = null;
						this.liteSelectToData = null;
						this.liteOptionsData = {
							listThread: commonUtils.getUser().vip ? 3 : 1,
                			runThread: commonUtils.getUser().vip ? 10 : 2,
							email: '',
							cron: '',
							excludeNames: [],
							allowedExtensions: [],
						};
						this.listTasks(() => {
							const newTaskName = commonUtils.judgeRepeatTaskName([], that);
							this.$refs.editInput.value = newTaskName;
							this.inputValue = newTaskName;
						});
						this.createTasking = false;
					})
					return;
				}
				//判断是否是临时用户，然后提醒用户进行绑定邮箱
                // console.log(this.pOptions);
                // return;
				let user = commonUtils.getUser();
				if (commonUtils.testUserIsTourist(user)) {
					this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
					return false;
				}
				if (this.mulitDrives.length && this.singleDrives.name) {
					let that = this;
					var executeData;
					//流量不足弹窗提醒
					let usedTraffic = user.usedBytes;
                    //  if(user.vip && user.payLevel > 1){
                    //   usedTraffic = user.payUsedTraffic;
                    // }
                	if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
						var upgradeNewDialog = this.$refs.upgradeNewDialog;
						upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
						upgradeNewDialog.curItem = 'traffic';
						upgradeNewDialog.isShow = true;
						return false;
					}
					let addData = new taskTransferUtils.addTaskData(user.id, 2, this.inputValue, taskTransferUtils.createSyncFromItems(
						this.singleDrives), taskTransferUtils.createSyncToItems(this.mulitDrives), this.pOptions, {
						type: 'Now',
						clientTime: commonUtils.getNowDateFormat()
					});
                    addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
					if (addData.toItems.length > 200) {
						that.loading = false;
						that.$toast({
							text: this.$t('language.cloudSync.aimRemind'),
							type: 'fail',
							idValue: "cloudSync"
						});
						return false;
					}
					if (this.$store.state.taskListNotGropArr.length >= 5000) {
						that.$toast({
							text: this.$t('language.exception.maxTaskRemind'),
							type: 'fail',
							idValue: "cloudTransfer"
						});
						that.loading = false;
						return false;
					}
					if (!addData.n) {
						this.$refs.editInput.cancelTaskName();
						addData.n = this.$refs.editInput.oldNameValue;
					}
					//iCloudPhotos文件夹作为目标，同步目标只能选择相簿
					if(addData.toItems.length>0 && addData.toItems[0].driveType == "iCloudPhotos"){
						let isForder = addData.toItems[0].docType == "FOLDER";
						if(isForder){
							let errorTip;
							if(addData.toItems[0].fileId == 'root'){
								errorTip = that.$t('language.exception.notSelectICloudPhotosSyncRoot');
							}else{
								errorTip = that.$t('language.exception.notSelectICloudPhotosSync');
							}
							that.$toast({
								text: errorTip,
								type: 'note',
								idValue: "cloudSync"
							});
							that.loading=false;
							that.addTaskFlag = true;
							return false;
						}
						//如果选择了所有文件都放在一个目录下，则报错
						if(this.pOptions.keepRoot == 0){
							that.$toast({
								text: that.$t('language.exception.onlySaveAlbums'),
								type: 'note',
								idValue: "cloudSync"
							});
							that.loading=false;
							that.addTaskFlag = true;
							return false;
						}
					}
					that.$nextTick(() => {
						if (that.addTaskFlag) {
							that.addTaskFlag = false;
							that.loading = true;
                            if(!this.realTimeMode){
                               this.Utils.doTasksRequest('add', addData).then(res => {
								that.addTaskFlag = true;
								if (res.status == 200) {
									taskListUtils.exeSuccessEnd('syncFlow', 'taskList', res.tasks, that);
								} else {
									that.loading = false;
									that.$toast({
										text: res.msg,
										type: 'fail',
										idValue: "cloudSync"
									});
								}
							});
                            }else{
                                var idlingCheck = localStorage.getItem(user.id+'check');
                                idlingCheck = JSON.parse(idlingCheck);
                                if(!idlingCheck){
                                    this.loading = false;
                                    this.$refs.idlingDialog.idlingShow=true;
                                    this.$refs.idlingDialog.addData = addData;
                                    return;
                                }
                                this.Utils.doRealtimeSyncRequest('create', addData).then(res => {
								that.addTaskFlag = true;
								if (res.message == 'success') {
                                    res.tasks[0].status= res.status;
									taskListUtils.exeSuccessEnd('syncFlow', 'taskList', res.tasks, that);
								} else if(res.reason=="CharacterLimit"){
                                    that.loading = false;
									that.$toast({
										text:  this.$t('language.cloudExploer.'+res.reason),
										type: 'fail',
										idValue: "cloudSync"
									});
                                }else{
									that.loading = false;
									that.$toast({
										text:  this.$t('language.exception.'+res.reason),
										type: 'fail',
										idValue: "cloudSync"
									});
								}
							});
                            }

						}
					});
				} else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.singleDrives.name) {
					this.boxFrom = "box-shake";
					setTimeout(() => {
						this.boxFrom = "box-shakeOrigin";
					}, 100);
				} else if (!this.mulitDrives.length) {
					this.boxTo = "box-shake";
					setTimeout(() => {
						this.boxTo = "box-shakeOrigin";
					}, 100);
				}
			},
			syncAddTask(event) {
				event.cancelBubble = true;
				//判断是否是临时用户，然后提醒用户进行绑定邮箱
				let user = commonUtils.getUser();
				if (commonUtils.testUserIsTourist(user)) {
					this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
					return false;
				}
				if (this.mulitDrives.length && this.singleDrives.name) {
					let user = commonUtils.getUser();
					//流量不足弹窗提醒
					 let usedTraffic = user.usedBytes;
                //      if(user.vip&&user.payLevel>1){
                //      usedTraffic = user.payUsedTraffic;
                //    }
                   if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
						var upgradeNewDialog = this.$refs.upgradeNewDialog;
						upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
						upgradeNewDialog.curItem = 'traffic';
						upgradeNewDialog.isShow = true;
						return false;
					}
					let addData = new taskTransferUtils.addTaskData(user.id, 2, this.inputValue, taskTransferUtils.createSyncFromItems(
						this.singleDrives), taskTransferUtils.createSyncToItems(this.mulitDrives), this.pOptions, this.pSchedules);
					addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                    if (addData.toItems.length > 200) {
						that.loading = false;
						that.$toast({
							text: this.$t('language.cloudSync.aimRemind'),
							type: 'fail',
							idValue: "cloudSync"
						});
						return false;
					}
					if (this.$store.state.taskListNotGropArr.length >= 5000) {
						that.$toast({
							text: this.$t('language.exception.maxTaskRemind'),
							type: 'fail',
							idValue: "cloudTransfer"
						});
						that.loading = false;
						return false;
					}
					if (!addData.n) {
						this.$refs.editInput.cancelTaskName();
						addData.n = this.$refs.editInput.oldNameValue;
					}
					this.$nextTick(() => {
						this.doAddSyncTasksRequest(addData);
					});
				} else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.singleDrives.name) {
					this.boxFrom = "box-shake";
					setTimeout(() => {
						this.boxFrom = "box-shakeOrigin";
					}, 100);
				} else if (!this.mulitDrives.length) {
					this.boxTo = "box-shake";
					setTimeout(() => {
						this.boxTo = "box-shakeOrigin";
					}, 100);
				}
			},
			//立刻执行同步任务
			addTaskSyncNow() {
				let that = this;
				//判断是否是临时用户，然后提醒用户进行绑定邮箱
				let user = commonUtils.getUser();
				if (commonUtils.testUserIsTourist(user)) {
					this.$refs.remindBindEmailDialog.remindBindEmailShow = true;
					return false;
				}
				if (this.mulitDrives.length && this.singleDrives.name) {
					let user = commonUtils.getUser();
					//流量不足弹窗提醒
					 let usedTraffic = user.usedBytes;
                    //  if(user.vip&&user.payLevel>1){
                    //  usedTraffic = user.payUsedTraffic;
                    //  }
                   if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
						var upgradeNewDialog = this.$refs.upgradeNewDialog;
						upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
						upgradeNewDialog.curItem = 'traffic';
						upgradeNewDialog.isShow = true;
						return false;
					}
					var executeData;
					let addData = new taskTransferUtils.addTaskData(user.id, 2, this.inputValue, taskTransferUtils.createSyncFromItems(
						this.singleDrives), taskTransferUtils.createSyncToItems(this.mulitDrives), this.pOptions, this.pSchedules);
                     addData.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
					if (addData.toItems.length > 200) {
						that.loading = false;
						that.$toast({
							text: this.$t('language.cloudSync.aimRemind'),
							type: 'fail',
							idValue: "cloudSync"
						});
						return false;
					}
					if (this.$store.state.taskListNotGropArr.length >= 5000) {
						that.$toast({
							text: this.$t('language.exception.maxTaskRemind'),
							type: 'fail',
							idValue: "cloudTransfer"
						});
						that.loading = false;
						return false;
					}
					if (!addData.n) {
						this.$refs.editInput.cancelTaskName();
						addData.n = this.$refs.editInput.oldNameValue;
					}
					if (that.addTaskFlag) {
						that.addTaskFlag = false;
						this.$nextTick(() => {
							this.Utils.doTasksRequest('add', addData).then(res => {
								that.addTaskFlag = true;
								if (res.status == 200) {
									if (res.group_id) {
										executeData = new taskListUtils.executeData(user.id, 2, null, res.group_id);
									} else {
										executeData = new taskListUtils.executeData(user.id, 2, res.tasks[0].id, null);
									}
									taskListUtils.addLength(this);
									that.doExeCuteSyncTasksRequest(executeData, res.tasks);
								} else {
									that.$toast({
										text: res.msg,
										type: 'fail',
										idValue: "cloudSync"
									});

								}
							});
						});
					}
				} else if ((!this.mulitDrives.length && !this.singleDrives.name) || !this.singleDrives.name) {
					this.boxFrom = "box-shake";
					setTimeout(() => {
						this.boxFrom = "box-shakeOrigin";
					}, 100);
				} else if (!this.mulitDrives.length) {
					this.boxTo = "box-shake";
					setTimeout(() => {
						this.boxTo = "box-shakeOrigin";
					}, 100);
				}
			},
			doAddSyncTasksRequest(addData) {
				let that = this;
				if (that.addTaskFlag) {
					that.addTaskFlag = false;
					that.loading = true;
					this.Utils.doTasksRequest('add', addData).then(res => {
						that.addTaskFlag = true;
						if (res.status == 200) {
							taskListUtils.exeSuccessEnd('syncFlow', 'taskList', res.tasks, that);
						} else {
							that.loading = false;
							that.$toast({
								text: res.msg,
								type: 'fail',
								idValue: "cloudSync"
							});
						}
					});
				}
			},
			doExeCuteSyncTasksRequest(executeData, tasks) {
				let that = this;
				if (that.addTaskFlag) {
					that.addTaskFlag = false;
					that.loading = true;
					that.Utils.doTasksRequest('execute', executeData).then(res => {
						that.addTaskFlag = true;
						if (res.status == 200) {
							$.each(tasks, function(i, item) {
								item.status = 'Waiting';
							});
							taskListUtils.exeSuccessEnd('syncFlow', 'taskList', tasks, that);
						} else {
							that.loading = false;
							that.$toast({
								text: res.msg,
								type: 'fail',
								idValue: "cloudSync"
							});
						}
					});
				}
			},
			//清除界面数据
			clearPageChoose() {
				let that = this;
				that.mulitDrives = [];
				that.singleDrives = {};
				that.hasSelectItemsMore = false;
				that.hasSelectItems = false;
				that.hasSelect = true;
				that.checkedSchedule = false;
				that.addTaskShow = false;
				let sourceDialg = that.$refs.syncSourceDialog;
				let aimDialog = that.$refs.syncAimsDialog;
				sourceDialg.checkedNodes = [];
				aimDialog.checkedNodes = [];
				that.$store.state.clickItem = -1;
				that.$store.state.arr = [];
				that.$store.state.syncClickItem = -1;
				that.$store.state.syncArr = [];
				for (let i = 0; i < sourceDialg.$refs.tree.length; i++) {
					sourceDialg.$refs.tree[i].open = false;
				}
				$.each(aimDialog.model, function(index, item) {
					item.open = false;
				});
				let div1 = sourceDialg.$refs['elscrollbar'].wrap;
				let div2 = aimDialog.$refs['elscrollbar'].wrap;
				that.$nextTick(() => {
					div1.scrollTop = 0;
					div2.scrollTop = 0;
				});
				sourceDialg.scrollTopValue = 0;
				aimDialog.scrollTopValue = 0;
				that.$refs.syncOptionsDialog.clearAllData();
				that.$refs.transferScheduleDialog.initPopup();
                if(!this.realTimeMode){
				this.onChangeOption(this.$t('language.popup.onewaySync'));
				// this.$refs.cloudSelect.currentValue = this.$t('language.popup.onewaySync');
                }else{
                this.onChangeRealTimeOption(this.$t('language.cloudSync.realTimeSync'));
				 this.$refs.syncOptionsDialog.way = 10;
                  this.pOptions.way = 10;
                  this.$refs.syncOptionsDialog.$refs.tab1.onChangeOptionOne(this.$t('language.popup.onewaySync'));
                  this.$refs.syncOptionsDialog.$refs.tab1.$refs.selectOne.currentValue=this.$t('language.popup.onewaySync');
                  this.twoWayShow = false;
                }
			},
            getWidth(){
                  let result;
            if (this.$i18n.locale == 'portuguese') {
                result = 200 + 'Px';
            }
            if (this.$i18n.locale == 'italian') {
                result = 220+ 'Px';
            }
            if (this.$i18n.locale == 'spanish') {
                result = 205 + 'Px';
            }
            return result;
            }
		}
	};
</script>

<style>
    .realTime-choose-button{
        min-width: 160Px;
        height: 30Px;
        float: left;
        border-radius: 2Px;
        line-height: 30Px;
        text-align: center;
        font-size: 14Px;
        cursor: pointer;
        padding: 0 10Px 0 10Px;
        box-sizing: border-box;
    }
    .realTime-select{
       color: #fff;
       background: #6f80db;
    }
    .realTime-no-select{
       color: #6f80db;
       background: #fff;
    }
	.sync-right-body {
		width: 100%;
		height: calc(100% - 90px);
		/*no*/
		background-color: #f2f7fe !important;
		position: relative;
		top: 90Px;
        overflow-x: hidden;
	}

	/*定义滑块，内阴影及圆角*/
	.sync-right-body::-webkit-scrollbar {
		width: 9px;
		/*no*/
		height: 9px;
		/*no*/
		background-color: #fff;
	}

	.sync-right-body::-webkit-scrollbar-thumb {
		height: 1px;
		/*no*/
		border-radius: 5px;
		/*no*/
		background-color: #becae4;
	}

	.sync-choose {
		width: 80%;
		height: 35px;
		/*no*/
		margin: auto;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
	}

	.arrow-position-reverse {
		transform: rotate(180deg);
		position: relative;
		top: 125px;
		/*no*/
	}

	.arrow-top-position {
		position: relative !important;
		top: 105px !important;
		/*no*/
	}

	.item-formicon {
		width: 25px;
		/*no*/
		height: 25px;
		/*no*/
		float: left;
		position: relative;
		top: 10px;
		/*no*/
		margin-left: 10px;
		/*no*/
	}

	#cloudSync .el-loading-spinner i {
		color: #999999;
	}

	#cloudSync .el-loading-spinner {
		font-size: 45px;
		/*no*/
	}

    .realTime-font{
        font-size: 14Px;
        color: #5065bc;
        width: 75%;
        margin: auto;
        position: absolute;
        bottom: 40Px;
        left: 0;
        right: 0;
        min-height: 25Px;
        border: 1Px solid #bcc5f7;
        line-height: 25Px;
        border-radius: 2Px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/workspace/cloud_sync.vue